import { TABLE_CONFIG, TABLE_CONFIG_TYPE } from '../../constants/table/index'
import './style.css'
import ReactPaginate from 'react-paginate'
import newStatus from '../../assets/images/new-status.svg'
import cancelStatus from '../../assets/images/cancel-status.svg'
import paidStatus from '../../assets/images/paid-status.svg'
import resendStatus from '../../assets/images/resend.svg'
import Submitted from '../../assets/images/Submitted.svg'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootReducers } from '../../redux/reducers'
import { ACCOUNT_LOCK_MESSAGE, ETR_STATUS } from '../../constants'
import { DisplayStatusName, DisplayStringDateToThaiDateFormat } from '../../helpers/texthelper'
import { isCancelable } from '../../helpers/roles'
import ShowButtonTransfer from '../ShowButtonTransfer/ShowButtonTransfer'
import { calculateAgingDay } from '../../helpers/reportHelper'

interface TABLE_PROP_TYPE {
  list: any[]
  itemsPerPage: number
  onCancel: (id: number, eTRNo: string) => void
  onHandleStatus: (id: number, eTRNo: string) => void
  isShowConfirmButton: boolean
  total: number
  onPageClick: (page: number) => void
  handleOpenTransferCompleteModal: (id: number, eTRNo: string) => void
}

export const Table: React.VFC<TABLE_PROP_TYPE> = ({
  list,
  onCancel,
  onHandleStatus,
  itemsPerPage,
  isShowConfirmButton,
  total,
  onPageClick,
  handleOpenTransferCompleteModal
}) => {
  const loginState = useSelector((state: RootReducers) => state.loginReducer)

  //const [currentItems, setCurrentItems] = useState<any>([])
  const [pageCount, setPageCount] = useState(0)
  const [itemOffset, setItemOffset] = useState(0)
  const renderHeader = (header: TABLE_CONFIG_TYPE) => {
    return header.header.map(rowHeader => <th key={rowHeader.id}>{rowHeader.name}</th>)
  }

  const displayCellData = (rawData: string, colName: string, optionalData: string, id: number) => {
    if (colName === 'receiptNo') {
      return (
        <Link className="detail-link" to={'/documentDetail/' + id}>
          {rawData}
        </Link>
      )
    } else {
      return displayDate(rawData, colName, optionalData)
    }
  }

  const renderStatus = (status: string, tooltipText: string) => {
    return (
      <div className="tooltip">
        <img src={status} alt="New-status" />
        <span className="tooltiptext">{tooltipText}</span>
      </div>
    )
  }

  const showStaffinfo = (data: string) => {
    if (isShowConfirmButton) return '\r\n โดย ' + data
    return ''
  }

  const displayDate = (rawData: string, colName: string, optionalData: string) => {
    if (colName === 'receiptdate') {
      const displayDate = rawData.split('.')[0]
      const result = DisplayStringDateToThaiDateFormat(displayDate)
      return result
    } else if (colName === 'status') {
      if (rawData === ETR_STATUS.NEW_ETR) {
        return renderStatus(newStatus, DisplayStatusName(ETR_STATUS.NEW_ETR))
      }
      if (rawData === ETR_STATUS.CANCEL_ETR) {
        return renderStatus(cancelStatus, DisplayStatusName(ETR_STATUS.CANCEL_ETR))
      }
      if (rawData === ETR_STATUS.RESEND_ETR) {
        return renderStatus(resendStatus, DisplayStatusName(ETR_STATUS.RESEND_ETR))
      }
      if (rawData === ETR_STATUS.SUBMITED_ETR) {
        return renderStatus(Submitted, DisplayStatusName(ETR_STATUS.SUBMITED_ETR))
      }
      if (rawData === ETR_STATUS.SUCCESS_ETR) {
        //return <img src={paidStatus} alt="Success-status" />
        return renderStatus(
          paidStatus,
          DisplayStatusName(ETR_STATUS.SUCCESS_ETR) + showStaffinfo(optionalData)
        )
      }
    } else if (colName === 'customerMail') {
      if (rawData.length > 0) {
        return rawData
      }
      if (rawData.length == 0) {
        return optionalData
      }
    } else if (colName === 'aging') {
      return calculateAgingDay(rawData)
    }

    return rawData
  }

  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage
    //console.log(`itemOffset = ${itemOffset}, endOffset = ${endOffset}`)

    if (list) {
      setPageCount(Math.ceil(total / itemsPerPage))
    }
  }, [list, itemOffset, itemsPerPage])

  // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % (total > 0 ? total : 1)
    //console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`)
    setItemOffset(newOffset)
    onPageClick(event.selected + 1)
  }

  const renderBody = (allList: any, isShowConfirmButton: boolean) => {
    return allList?.map?.((rowBody: any, index: number) => {
      return (
        <tr key={index}>
          {TABLE_CONFIG.header.map(column => (
            <td
              key={column.id}
              className={column.id === 'status' ? 'position-icon-status' : `column-${column.id}`}
            >
              {displayCellData(
                column.id === 'aging' ? rowBody : rowBody[column.id],
                column.id,
                rowBody['updateBy'],
                rowBody['id']
              )}
            </td>
          ))}
          {/* <td className="button">
            <div className="action-wrapper">
              <button
                className="cancel-button"
                disabled={
                  rowBody.status === ETR_STATUS.CANCEL_ETR ||
                  rowBody.status === ETR_STATUS.SUBMITED_ETR ||
                  rowBody.status === ETR_STATUS.SUCCESS_ETR ||
                  !isCancelable(
                    loginState.account?.agentInfo.role as string,
                    rowBody['createBy'],
                    loginState.account?.agentInfo.agentId as string
                  ) ||
                  loginState.account?.agentInfo.accountLock
                }
                onClick={() => onCancel(rowBody.id, rowBody.receiptNo)}
              >
                <div className="tooltip">
                  <span
                    className={`${
                      loginState.account?.agentInfo.accountLock
                        ? 'account_lock_table_tooltiptext '
                        : 'hide'
                    }`}
                  >
                    {ACCOUNT_LOCK_MESSAGE}
                  </span>
                  ยกเลิก
                </div>
              </button>

              <ShowButtonTransfer>
                <button
                  className="confirm-submit-button"
                  disabled={
                    rowBody.status === ETR_STATUS.SUCCESS_ETR ||
                    rowBody.status === ETR_STATUS.CANCEL_ETR ||
                    rowBody.status === ETR_STATUS.SUBMITED_ETR
                  }
                  onClick={() => onHandleStatus(rowBody.id, rowBody.receiptNo)}
                >
                  นำส่งเข้าบริษัท
                </button>
              </ShowButtonTransfer>

              <button
                className="confirm-submit-button"
                style={isShowConfirmButton ? { display: 'inline-block' } : { display: 'none' }}
                disabled={
                  rowBody.status === ETR_STATUS.SUCCESS_ETR ||
                  rowBody.status === ETR_STATUS.CANCEL_ETR
                }
                onClick={() => handleOpenTransferCompleteModal(rowBody.id, rowBody.receiptNo)}
              >
                นำส่งสำเร็จ
              </button>
            </div>
          </td> */}
        </tr>
      )
    })
  }

  return (
    <>
      <div className="content-table">
        <table className="table-list">
          <thead>
            <tr>{renderHeader(TABLE_CONFIG)}</tr>
          </thead>
          <tbody key="tbody">{renderBody(list, isShowConfirmButton)}</tbody>
        </table>
      </div>
      <div className="content-pagination">
        <ReactPaginate
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          previousLabel="<"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-nav"
          nextClassName="page-item"
          nextLinkClassName="page-nav"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={() => null}
        />
      </div>
    </>
  )
}
